import { JSX } from "preact";
import powerStations from "../../data/powerStations";
import alternatorChargers from "../../data/alternatorChargers";

const roundedFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const centsFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const formatPrice = (amount: number, showCents: boolean) => {
  if (typeof amount !== "number" || Number.isNaN(amount)) return null;
  return showCents
    ? centsFormatter.format(amount)
    : roundedFormatter.format(amount);
};

interface ProductPriceProps extends JSX.HTMLAttributes<HTMLSpanElement> {
  brand: string;
  model: string;
  showCents?: boolean;
}

const ProductPrice = ({
  brand,
  model,
  showCents = false,
  ...props
}: ProductPriceProps) => {
  const brandPowerStations = powerStations[brand]?.powerStations || {};

  // Try power-station lookup first
  let product = brandPowerStations[model];

  // If not found, check alternator chargers (slower as its an array)
  if (!product) {
    product = (alternatorChargers[brand] || []).find((p) => p.name === model); //TODO: Convert base data file to map to improve lookup
  }

  //TODO: Check batteries and other products

  // Fallback
  if (!product || !product.price) {
    return <span {...props}>TBD</span>;
  }

  return <span {...props}>{formatPrice(product.price, showCents)}</span>;
};

export default ProductPrice;
